module.exports = __webpack_public_path__ + "img/bg.897e8ce0.png";